import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

// Element Plus 表格在 tab 切换时可能触发 ResizeObserver 无害警告，避免 dev overlay 报错
window.addEventListener('error', (e) => {
	if (e.message?.includes('ResizeObserver')) {
		e.stopImmediatePropagation()
	}
})

const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(store)
app.use(router)
app.use(ElementPlus)
app.mount('#app')